<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content preview">
      <component :is="tag" :src="src" frameBorder="0"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'img'
    },
    src: {
      type: String
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  width: 75%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>